import React from "react";
import useGlobalHook from "use-global-hook";
import * as actions from "../Actions/NewsletterAction";

const initialState = {
  status: 200,
  isLoading: false,
  isSaving: false,
  message: "",
  header: {},
  data: [],
  dataUser: [],
  dataResume: {},
  usersStatus: [],
  lastPage: false,
  // alldata: [],
};

const NewsletterStore = useGlobalHook(React, initialState, actions);

export default NewsletterStore;
